// Static branding & nav data (used across the whole site, not company-specific)
export const brand = {
  name: "ReviewUK",
  domain: "review-uk.co.uk",
  tagline: "Honest customer reviews of UK companies",
};

export const topNavLinks = [
  { label: "Browse Companies", href: "/" },
  { label: "Submit Review", href: "/submit-review" },
  { label: "Helpful Tools", href: "/tools" },
  { label: "For Business", href: "/for-business" },
];
